import { AgGridColumnProps } from 'ag-grid-react';

export const teamTablesColumnDefinitions: AgGridColumnProps[] = [
    {
        field: 'label',
        headerName: 'Table label',
        sortable: true,
        flex: 2,
    },
];